<template>
    <div class="site__body">
        <div class="block-space block-space--layout--spaceship-ledge-height"></div>
        <div class="block order-success">
            <div class="container">
                <div class="order-success__body">
                    <div class="order-success__header">
                        <div class="order-success__icon">
                            <svg width="100" height="100">
                                <path d="M50,100C22.4,100,0,77.6,0,50S22.4,0,50,0s50,22.4,50,50S77.6,100,50,100z M50,2C23.5,2,2,23.5,2,50
                                    s21.5,48,48,48s48-21.5,48-48S76.5,2,50,2z M44.2,71L22.3,49.1l1.4-1.4l21.2,21.2l34.4-34.4l1.4,1.4L45.6,71
                                    C45.2,71.4,44.6,71.4,44.2,71z" />
                            </svg>
                        </div>
                        <h1 class="order-success__title">Thank you</h1>
                        <div class="order-success__subtitle">Your order has been received</div>
                        <div class="order-success__actions">
                            <router-link to="/home" class="btn btn-sm btn-primary">Go To Homepage</router-link>
                        </div>
                    </div>

                    <order-success-details-b v-if="customerIndicator === 'B'" :ordered_summary="ordered_summary" ></order-success-details-b>
                    <order-success-details v-if="customerIndicator === 'C'" :ordered_summary="ordered_summary" :ordered_items="ordered_items"></order-success-details>

                    <order-success-addresses :billingInfo="billingInfo" :shippingInfo="shippingInfo"></order-success-addresses>

                </div>
            </div>
        </div>
        <div class="block-space block-space--layout--before-footer"></div>
    </div>

</template>

<script>
import OrderSuccessDetailsB from './OrderSuccessDetailsB';
import OrderSuccessDetails from './OrderSuccessDetails';
import OrderSuccessAddresses from './OrderSuccessAddresses';
import { mapGetters } from 'vuex';

export default {
    name: 'OrderSuccess',
    components: {
        OrderSuccessDetails,
        OrderSuccessAddresses,
        OrderSuccessDetailsB
    },
    data() {
        return {
            billingInfo: {},
            shippingInfo: {},
            ordered_summary: {},
            ordered_items: [],
            backordered: [],
        }
    },
    computed: {
        ...mapGetters([
            'customerIndicator',
        ]),
    },
    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
        
        let ordertotals = this.$store.getters['cart/totals'];
        let promo_code = this.$store.getters['cart/promo_code'];
        let billingdetails = this.$store.getters['cart/billingdetails'];
        let shippingdetails = this.$store.getters['cart/shippingdetails'];
        let billphone = '', shipphone = '';
        let order_notes = this.$store.getters['cart/order_notes'];
        
        this.ordered_items = this.$store.getters['cart/ordered_items'];
        this.backordered = this.$store.getters['cart/backordered_items'];

        console.table(this.ordered_items);
        
        // this.$store.getters['cart/cart'].forEach(item => {
        //     console.log(item);
        //     this.ordered_items.push({
        //         "product_id": item.ID,
        //         "product_name": item.item,
        //         "product_desc": item.desc,
        //         "price": item.linetotal,
        //         "quantity": item.quantity,
        //         "image": item.image,
        //         "url": ("/product-detail/" + item.manufacturer + "/" + item.item),

        //         "linenumber": item.linenumber,
        //         "locationid": item.locationid,
        //         "locationcity": item.locationcity,
        //         "locationname": item.locationname,
        //         "locationstate": item.locationstate,
        //         "manufacturer": item.manufacturer,
        //         // "backorder": item.backorder,
        //     });
        // });

        this.ordered_summary = {
            order_number    : this.$store.getters['cart/ordernumber'],
            created_date    : this.$store.getters['cart/orderdate'],
            payment_method  : this.$store.getters['cart/paymentmethod'],
            promo_code      : promo_code.code,
            subtotal        : ordertotals[0].subtotal,
            tax             : ordertotals[0].taxtotal,
            core_changes    : ordertotals[0].coretotal,
            shipping        : ordertotals[0].shippingtotal,
            grandtotal      : ordertotals[0].ordertotal,
            discounttotal   : ordertotals[0].discounttotal,
            order_notes     : order_notes,
        };

        if (billingdetails.billingphone === '') {
            if (this.$store.getters['cart/phone'] != '') {
                billphone = this.$store.getters['cart/phone']
            }
        } else {
            billphone = billingdetails.billingphone;
        }

        if (shippingdetails.shippingphone === '') {
            if (this.$store.getters['cart/phone'] != '') {
                shipphone = this.$store.getters['cart/phone']
            }
        } else {
            shipphone = shippingdetails.shippingphone;
        }

        this.billingInfo = {
            "customer_name"     : billingdetails.billingname,
            "customer_address"  : billingdetails.billingaddress1,
            "customer_address2" : billingdetails.billingaddress2,
            "customer_city"     : billingdetails.billingcity,
            "customer_state"    : billingdetails.billingstate,
            "customer_zipcode"  : billingdetails.billingzip,
            "customer_email"   : this.$store.getters['cart/email'],
            "customer_mobile"  : billphone
        };

        this.shippingInfo = {
            "customer_name"   : shippingdetails.shippingname,
            "customer_address": shippingdetails.shippingaddress1,
            "customer_address2": shippingdetails.shippingaddress2,
            "customer_city"   : shippingdetails.shippingcity,
            "customer_state"  : shippingdetails.shippingstate,
            "customer_zipcode": shippingdetails.shippingzip,
            "customer_email"  : this.$store.getters['cart/email'],
            "customer_mobile" : shipphone
        }

        this.$store.dispatch('cart/emptyCart');
        this.$store.dispatch('cart/emptyKits');
        this.$store.dispatch("vehicle/clearSelectedVehicle");
    },
    unmounted() {
        this.$store.dispatch('cart/emptyCart');
        this.$store.dispatch('cart/emptyKits');
        this.$store.dispatch("vehicle/clearSelectedVehicle");
        this.$store.dispatch('cart/emptyOrderItems');
        // this.$store.dispatch('cart/emptyOrderItems');
        this.$store.dispatch('cart/orderdetails', {
            "paymenttype": '',
            "purchaseorder": ''
        });
    }
}
</script>